import script from "./colorInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./colorInput.vue?vue&type=script&lang=ts&setup=true"

import "./colorInput.vue?vue&type=style&index=0&id=3bd70d9c&lang=less"

const __exports__ = script;

export default __exports__